/* CreativeWall 第2次改修 2026-10-02
   - 絞り込み：表記ゆれをまとめたチェック（同じグループの値をまとめてON/OFF）
   - カテゴリー：中カテゴリーの開閉 */
(function () {
  'use strict';
  // テーマの絞り込み処理より先に、同じグループの隠れたチェックをそろえる
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="checkbox"][data-cw-group]:not([hidden])')) return;
    var form = t.form || t.closest('form');
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"][hidden][data-cw-group]').forEach(function (m) {
      if (m.getAttribute('data-cw-group') === t.getAttribute('data-cw-group')) m.checked = t.checked;
    });
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cw-toggle]');
    if (!b) return;
    e.preventDefault();
    var li = b.closest('li');
    var list = li && li.querySelector('.cw-cat-small');
    if (!list) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    list.hidden = open;
    // 開閉欄の高さを内容に合わせる（テーマの開閉部品が高さを固定している場合）
    var body = b.closest('[data-collapsible-body]');
    if (body && body.style.height && body.style.height !== 'auto') body.style.height = 'auto';
  });
})();
